import { styled } from '../../../theme';
import { FacebookButton } from '../../FacebookButton';

export const FacebookContinueButton = styled(FacebookButton).attrs(() => ({
	text: 'Fortsätt med Facebook',
}))`
	width: 100%;
`;
